"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenKommissionsverkauf } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Kommissionsverkauf() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Kommissionsverkauf - Auto sicher über Händler verkaufen"
        link="/guides/kommissionsverkauf"
        linkname="Kommissionsverkauf"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Lohnt sich der Verkauf an Kommissionsläden?"
              leftText={
                <>
                  <p>
                    Du möchtest dein Auto verkaufen, aber nicht unter Wert
                    abgeben oder dich mit zeitraubenden Anzeigen und Probefahrten
                    herumschlagen? Dann ist der Kommissionsverkauf die richtige
                    Lösung für dich.
                  </p>
                  <p>
                    Beim Kommissionsverkauf verkaufst du dein Fahrzeug nicht
                    direkt, sondern über einen erfahrenen Händler, der in deinem
                    Auftrag den besten Preis erzielt. Du bleibst bis zum Verkauf
                    Eigentümer, hast also kein Risiko und profitierst gleichzeitig
                    vom professionellen Netzwerk, der Erfahrung und der Reichweite
                    des Händlers.
                  </p>
                  <p>
                    Über Autoeinfachlos kannst du dein Auto ganz einfach
                    verkaufen. Wir arbeiten mit über 5.000 geprüften Händlern in
                    Österreich zusammen und übernehmen die komplette Vermarktung -
                    von der Bewertung bis zur sicheren Auszahlung.
                  </p>
                </>
              }
              rightFirstTitle="Was bedeutet Kommissionsverkauf beim Auto?"
              rightFirstText={
                <>
                  <p>
                    Ein Kommissionsverkauf bedeutet, dass du dein Auto einem
                    Händler übergibst, der es in deinem Auftrag verkauft.
                  </p>
                  <p>
                    Du bleibst rechtlich weiterhin Eigentümer, bis der Verkauf
                    abgeschlossen ist.
                  </p>
                  <p>
                    Der Händler kümmert sich um alles, was beim Privatverkauf oft
                    aufwendig und riskant ist:
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Er erstellt das Inserat und übernimmt die Vermarktung.</li>
                    <li>Er führt Besichtigungen und Probefahrten durch.</li>
                    <li>Er verhandelt mit potenziellen Käufern.</li>
                    <li>Er schließt den Kaufvertrag ab.</li>
                  </ul>
                  <p>
                    Die rechtliche Grundlage bildet ein sogenannter
                    Kommissionsvertrag, in dem alle Bedingungen transparent
                    festgehalten werden: Verkaufspreis, Provision, Dauer der
                    Kommission und Abwicklungsmodalitäten.
                  </p>
                  <p>
                    <strong>Vorteile des Kommissionsverkaufs:</strong>
                  </p>
                  <ul className="custom-unordered-list">
                    <li>
                      Kein Risiko - das Auto bleibt dein Eigentum bis zur
                      Auszahlung.
                    </li>
                    <li>
                      Kein Aufwand - der Händler übernimmt Vermarktung und Verkauf.
                    </li>
                    <li>
                      Bester Preis - dank professioneller Präsentation und
                      Händlernetzwerk.
                    </li>
                  </ul>
                </>
              }
              rightSecondTitle="Kommissionsverkauf vs. direkter Ankauf - was ist besser?"
              rightSecondText={
                <>
                  <p>
                    Viele Autobesitzer stehen vor der Frage: Soll ich mein Auto
                    direkt verkaufen oder lieber über Kommission abwickeln?
                  </p>
                  <p>
                    Beide Varianten haben ihre Vorteile: welche besser ist, hängt
                    von deiner Situation ab.
                  </p>
                  <p>
                    <strong>Kommissionsverkauf</strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>Du hast mehr Zeit, um den besten Preis zu erzielen.</li>
                    <li>
                      Der Händler kann dein Auto gezielt am Markt positionieren.
                    </li>
                    <li>
                      Besonders geeignet für hochwertige Fahrzeuge, Oldtimer oder
                      seltene Modelle.
                    </li>
                  </ul>
                  <p>
                    <strong>Direkter Ankauf</strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>Du bekommst sofort dein Geld, ohne Wartezeit.</li>
                    <li>
                      Ideal, wenn du das Fahrzeug schnell verkaufen möchtest.
                    </li>
                    <li>
                      Perfekt bei Autos mit geringem Restwert oder dringendem
                      Liquiditätsbedarf.
                    </li>
                  </ul>
                  <p>
                    <strong>Unser Tipp:</strong> Wenn du Wert auf maximalen Erlös
                    legst, ist der Kommissionsverkauf eine gute Idee. Wenn du
                    schnell verkaufen willst, wähle den direkten Ankauf über
                    Autoeinfachlos.
                  </p>
                  <p>
                    Wir beraten dich transparent, welche Option für dich am
                    sinnvollsten ist. Oder du startest einfach ganz unverbindlich
                    deine Fahrzeugbewertung.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage2}
                revert
                h2
                isBig
                fontSize="36px"
                title="Ablauf des Autoverkaufs bei Autoeinfachlos"
                alt="Ablauf des Autoverkaufs bei Autoeinfachlos"
                text={
                  <>
                    <p>Der Ablauf ist einfach.</p>
                    <ul className="custom-unordered-list">
                      <li>Gib dein Auto online zur Bewertung ein.</li>
                      <li>Wir starten die Auktion im Händlernetzwerk.</li>
                      <li>Du erhältst das höchste Gebot.</li>
                      <li>Dein Auto wird direkt bei dir in Salzburg abgeholt.</li>
                      <li>Du bekommst dein Geld sicher und schnell.</li>
                    </ul>
                    <p>Schnell, fair und unkompliziert.</p>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage1}
                h2
                isBig
                fontSize="36px"
                title="Welche Fahrzeuge eignen sich für den Kommissionsverkauf?"
                alt="Welche Fahrzeuge eignen sich für den Kommissionsverkauf"
                text={
                  <>
                    <p>
                      Der Kommissionsverkauf lohnt sich besonders für Fahrzeuge,
                      die durch Zustand, Marke oder Ausstattung einen höheren
                      Marktwert haben und nicht binnen Stunden verkauft werden
                      müssen.
                    </p>
                    <p>
                      <strong>Typische Beispiele:</strong>
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Hochwertige Gebrauchtwagen</li>
                      <li>Luxusfahrzeuge und Sportwagen</li>
                      <li>Oldtimer und Sammlerfahrzeuge</li>
                      <li>Sondermodelle oder seltene Marken</li>
                    </ul>
                    <p>
                      Für günstigere Fahrzeuge oder Autos mit höherer Laufleistung
                      empfiehlt sich oft der direkte Ankauf, da der Marktwert
                      ohnehin klar definiert ist.
                    </p>
                    <p>
                      Wenn du dir unsicher bist, welche Variante für dich besser
                      passt, kannst du dein Auto einfach kostenlos bewerten lassen.
                      Wir zeigen dir transparent beide Optionen.
                    </p>
                    <p>
                      👉{" "}
                      <Link className="link" href="/auto-bewerten">
                        Jetzt Fahrzeugwert kostenlos ermitteln
                      </Link>
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufige Fragen rund um den Kommissionsverkauf"
              fragen={fragenKommissionsverkauf}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Kommissionsverkauf"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Auto verkaufen mit Autoeinfachlos - sicher, fair und stressfrei"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos sicher und stressfrei zu verkaufen."
                text={
                  <>
                    <p>
                      Der Autoverkauf mit Autoeinfachlos ist die ideale Lösung,
                      wenn du den besten Preis für dein Auto erzielen möchtest,
                      ohne dich selbst um den Verkauf zu kümmern.
                    </p>
                    <p>
                      Du profitierst von professioneller Vermarktung, fairen
                      Verhandlungen und einem starken Händlernetzwerk. Mit
                      Autoeinfachlos hast du einen Partner, der sich um alles
                      kümmert - von der Bewertung über die Vermarktung bis zur
                      Auszahlung.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default Kommissionsverkauf;
